import "../step1/prop1side.css";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function Prop2side() {
  const QuickQuotes = useSelector((state) => state.vehicledetail.quickquotes.data);
  console.log(QuickQuotes)
  const [Quote, setQuote] = useState(QuickQuotes)
  const [loading, setLoading] = useState(false);
  const state = useSelector((store) => store.addressdetail.choice);
  // let data = JSON.parse(localStorage.getItem("quickquotes"));
  useEffect(() => {
    if (state) {
      setLoading(true);
    }
  }, []);

  return loading ? (
    <div>
      <h1>Loading....</h1>
    </div>
  ) : (
    <div className="prop1parent-skb">
      <div className="prop1parent-skb-child">
        <div>
          <img
            src="https://www.godigit.com/content/dam/godigit/images/logo.svg"
            alt=""
          ></img>
        </div>
        <div>
          <span style={{ padding: "0px 10px 0px" }}>
            Vehicle No:
            {Quote?.vehicle?.licensePlateNumber}
          </span>{" "}
          <br />
          <span style={{ padding: "0px 10px 0px" }}>
            {Quote?.vehicle?.make} {Quote?.vehicle?.model}
          </span>
        </div>
      </div>

      <div className="prop1parent-skb-child">
        <div>
          <p>IDV:{Quote.vehicle.vehicleIDV.idv}</p>
          <p>NCB:{Quote.contract.currentNoClaimBonus}</p>
        </div>
        <div className="prop1parent-skb-child-grey">
          <p style={{ background: "#F5F5F5" }}>Zero Deprecation : N/A</p>
        </div>
      </div>

      <div className="prop1parent-skb-child">
        <div>
          <p style={{ color: "green", fontSize: "20px" }}>
            {Quote?.grossPremium}
          </p>
          <p style={{ color: "blue" }}>Premium Breakup</p>
        </div>
        <div>
          <p style={{ background: "#F5F5F5" }}>Working policy</p>
        </div>
      </div>
    </div>
  );
}

export { Prop2side };
